import React from 'react';
import HttpRounded from '@mui/icons-material/HttpRounded';
import InsertDriveFileRounded from '@mui/icons-material/InsertDriveFileRounded';
import StorageRounded from '@mui/icons-material/StorageRounded';
import TableChartRounded from '@mui/icons-material/TableChartRounded';
import { ReactComponent as BigQuerySvg } from '../../../assets/connectors/bigquery.svg';
import { ReactComponent as GoogleAdsSvg } from '../../../assets/connectors/google-ads.svg';
import { ReactComponent as GoogleDriveSvg } from '../../../assets/connectors/google-drive.svg';
import { ReactComponent as MCPSvg } from '../../../assets/connectors/mcp.svg';
import { ReactComponent as MySQLSvg } from '../../../assets/connectors/mysql.svg';
import { ReactComponent as OneDriveSvg } from '../../../assets/connectors/onedrive.svg';
import { ReactComponent as PostgresSvg } from '../../../assets/connectors/postgres.svg';
import { ReactComponent as RedshiftSvg } from '../../../assets/connectors/redshift.svg';
import { ReactComponent as SharePointSvg } from '../../../assets/connectors/sharepoint.svg';
import { ReactComponent as ShopifySvg } from '../../../assets/connectors/shopify.svg';
import { ReactComponent as HubSpotSvg } from '../../../assets/connectors/hubspot.svg';
import { ReactComponent as SnowflakeSvg } from '../../../assets/connectors/Snowflake.svg';
import { ReactComponent as AirtableSvg } from '../../../assets/connectors/airtable.svg';

const SVG_BY_TYPE: Record<string, React.FC<React.SVGProps<SVGSVGElement>>> = {
  postgres: PostgresSvg,
  postgresql: PostgresSvg,
  mysql: MySQLSvg,
  google_drive: GoogleDriveSvg,
  snowflake: SnowflakeSvg,
  redshift: RedshiftSvg,
  onedrive: OneDriveSvg,
  sharepoint: SharePointSvg,
  google_ads: GoogleAdsSvg,
  bigquery: BigQuerySvg,
  shopify: ShopifySvg,
  hubspot: HubSpotSvg,
  airtable: AirtableSvg,
  mcp: MCPSvg,
};

function normalizeConnectorTypeKey(raw?: string): string {
  if (!raw) return '';
  return raw
    .toLowerCase()
    .trim()
    .replace(/[\s-]+/g, '_');
}

/** Renders a connector logo when known; MUI fallback for compute/local/API/file-style types. */
export default function ConnectorTypeIcon({
  connectorType,
  size = 20,
}: {
  connectorType?: string;
  size?: number;
}) {
  const key = normalizeConnectorTypeKey(connectorType);
  const Svg = key ? SVG_BY_TYPE[key] : undefined;
  if (Svg) {
    return <Svg width={size} height={size} style={{ display: 'block', flexShrink: 0 }} aria-hidden />;
  }
  if (key === 'duckdb' || key === 'local') {
    return <TableChartRounded sx={{ fontSize: size, flexShrink: 0 }} color="action" aria-hidden />;
  }
  if (
    key === 'rest'
    || key.endsWith('_api')
    || key.includes('http')
    || key === 'api'
  ) {
    return <HttpRounded sx={{ fontSize: size, flexShrink: 0 }} color="action" aria-hidden />;
  }
  if (key.includes('file') || key.includes('drive') || key === 'csv' || key === 'excel') {
    return <InsertDriveFileRounded sx={{ fontSize: size, flexShrink: 0 }} color="action" aria-hidden />;
  }
  return <StorageRounded sx={{ fontSize: size, flexShrink: 0 }} color="action" aria-hidden />;
}
